import { store } from "@root/store";
export const CONTENT_TYPE = {
  FOLDER: 1,
  VIDEO: 2,
  DOCUMENT: 3,
  TEST: 4,
  // ONLY 4 CONTENT_TYPES ARE AT BACKEND, REST ARE FOR FRONTENT
  IMAGE: 5,
  ZIP: 6,
  SUBJECTIVE_TEST: 7,
};
import { getAwsAssets } from "@src/utils/index";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import { directDeepLink } from "@src/common/deepLinks";
import { hitDeeplinkPerformAction } from "@src/utils/hitDeeplink";
import { trackAnalyticsEvent } from "@src/utils/gtmDataLayer";
import toast from "react-hot-toast";
const playMobileVideo = (content) => {
  // console.log("A_________playMobileVideo inner");
  if (content.url) {
    //// alert"Play Video Clicked");
    window?.mobile?.performAction?.(
      `${DEEPLINK_ACTIONS.ACTION_PLAY_VIDEO}`,
      JSON.stringify(content)
    );
  }
};

const openDocument = (content) => {
  let url = {
    screen: `SCREEN_CONTENT`,
    paramOne: content.url,
    paramTwo: content.name,
    paramThree: content.description,
  };

  if (content.format == "pdf") {
    //// alert"Open PDF");
    // window?.mobile?.performAction?.(
    //   `${DEEPLINK_ACTIONS.ACTION_OPEN_PDF}`,
    //   JSON.stringify(content)
    // );

    //// alert"Download PDF");

    window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));
    //// alert"now downloading....");
    // window?.mobile?.performAction?.(
    //   `${DEEPLINK_ACTIONS.ACTION_DOWNLOAD_FILE}`,
    //   JSON.stringify(content)
    // );
  } else if (content.format == "zip") {
    //// alert"Download Zip");
    window?.mobile?.performAction?.(
      `${DEEPLINK_ACTIONS.ACTION_DOWNLOAD_FILE}`,
      JSON.stringify(content)
    );
  } else {
    //// alert"Open Image");

    window?.mobile?.onDeeplinkExecutedV2(JSON.stringify(url));
    // window?.mobile?.performAction?.(
    //   `${DEEPLINK_ACTIONS.ACTION_OPEN_IMAGE}`,
    //   JSON.stringify(content)
    // );
  }
};

const openTest = (content) => {
  //// alert"Open Test");
  window?.mobile?.performAction?.(
    `${DEEPLINK_ACTIONS.ACTION_TEST_ATTEMPT}`,
    JSON.stringify(content)
  );
};

// HANDLING CLICK ON ITEM
const handleItemClicked = (content) => {
  // console.log("A_________handleItemClicked");
  const { id, contentType } = content;
  switch (contentType) {
    case CONTENT_TYPE.FOLDER: {
      changeFolderRoute(id);
      break;
    }
    case CONTENT_TYPE.VIDEO: {
      // if (userDetails.type === USER_TYPES.TUTOR && !isProcessed) openCourseLockedModal(CONSTANTS.PROCESSING_COURSE_CONTENT);
      // if (userDetails.type === USER_TYPES.TUTOR && !isWebVideoAllowed) openCourseLockedModal(CONSTANTS.MOBILE_ONLY_COURSE_CONTENT);
      // if (userDetails.type === USER_TYPES.TUTOR && isReselling) openCourseLockedModal(CONSTANTS.MOBILE_ONLY_COURSE_CONTENT);
      // if (isVideoExhausted()) openCourseLockedModal(CONSTANTS.EXHAUSTED_COUNT_COURSE_CONTENT);
      // else openVideoModal();
      // console.log("A_________playMobileVideo outer");
      playMobileVideo(content);
      break;
    }
    case CONTENT_TYPE.DOCUMENT: {
      openDocument(content);
      break;
    }
    case CONTENT_TYPE.TEST: {
      openTest(content);
      break;
    }
  }
};
export const openInstallmentUtil = (selectedState) => {
  // console.log("L_______", "openInstallmentUtil");
  const installmentObj =
    store.getState()?.overviewReducer?.overViewDetails?.course?.installments;
  const color = store.getState()?.persistedDataReducer?.appAccent;
  const is_apk = localStorage.getItem("isAPKFlag");
  
  const isMoneyBack = store.getState()?.overviewReducer?.overViewDetails?.course?.metaData?.addOnData?.addOnOptionId;
  const isMoneyBackRemoveEnable = store.getState()?.overviewReducer?.moneyBackGuarantee?.isRemoveButtonEnable;
  const priceSummaryOptedAddOnId = store.getState()?.overviewReducer?.overViewDetails?.course?.installments?.paidInstallmentSummary?.addonDetails?.priceSummaryOptedAddOnId

  const deeplinkJSON =
    installmentObj?.installmentData?.deeplink ||
    installmentObj?.paidInstallmentSummary?.button?.deeplink;

  if (!deeplinkJSON?.paramOne) {
    trackAnalyticsEvent("exception_handled", {
      source: "openInstallmentUtil 1 [deeplink.paramOne]",
      message: "Missing installment deeplink or paramOne",
    });
    toast.error("Unable to open installments. Please try again.");
    return;
  }

  let newUrl;
  try {
    newUrl = new URL(deeplinkJSON.paramOne);
  } catch (error) {
    trackAnalyticsEvent("exception_handled", {
      source: "openInstallmentUtil 2 [deeplink.paramOne]",
      message: error?.message || "Invalid installment deeplink URL",
      input_preview:
        typeof deeplinkJSON.paramOne === "string"
          ? deeplinkJSON.paramOne.slice(0, 120)
          : undefined,
    });
    toast.error("Unable to open installments. Please try again.");
    return;
  }

  newUrl.searchParams.append("isNewCourseView", `1`);
  color && newUrl.searchParams.append("color", `${color}`);
  newUrl.searchParams.append("is_apk", `${is_apk || 0}`);

  if (selectedState) {
    newUrl.searchParams.append("state", `${selectedState}`);
  }
  if (isMoneyBack && isMoneyBackRemoveEnable ) {
    newUrl.searchParams.append("optedAddOn", isMoneyBack);
  }
  if(priceSummaryOptedAddOnId){
    newUrl.searchParams.append("addOnId", priceSummaryOptedAddOnId)
  }
  const deeplinkPayload = {
    ...deeplinkJSON,
    paramOne: newUrl.toString(),
  };
  // console.log(deeplinkPayload);
  hitDeeplinkPerformAction(
    COMMON_DEEPLINK_ACTIONS.OPEN_WEBVIEW,
    JSON.stringify(deeplinkPayload),
    JSON.stringify(deeplinkPayload)
  );
};
export const updateWebBackEventStatus = (status) =>{
  hitDeeplinkPerformAction(
    COMMON_DEEPLINK_ACTIONS.ACTION_WEB_BACK_EVENT_ADDED,
    JSON.stringify({status})
  );
}
export default handleItemClicked;
